module.exports = __webpack_public_path__ + "img/92ccb6f3a8b841bac2addd83d91cd916.bf98600e.png";